export default __webpack_public_path__ + "static/media/g2022-2.c4aa390a.jpeg";